module.exports = __webpack_public_path__ + "img/资源 185.67009ede.png";